import { useEffect, useState, useContext } from 'react'
import { ReportingContext } from '../../../../contexts/reporting-context'
import DataCard from '../../../atoms/DataCard/datacard'
import { SeatBooking, Team } from '../../../../types/andTypes'
import { TeamExtensions } from '../../../../constants'

export const MostVisitingTeam = () => {
  const { reportBusinessUnit, reportSeatBookingsByBU, reportTeam } = useContext(ReportingContext)

  const [visitingTeam, setVisitingTeam] = useState('')
  const [numberSeatsBooked, setNumberSeatsBooked] = useState(0)

  useEffect(() => {
    if (reportSeatBookingsByBU.length === 0) {
      setVisitingTeam('-')
      setNumberSeatsBooked(0)
    } else {
      const [team, seats] = fetchMostVisitingTeam(reportSeatBookingsByBU)
      setVisitingTeam(team)
      setNumberSeatsBooked(seats)
    }
  }, [reportSeatBookingsByBU])

  const fetchMostVisitingTeam = (reportSeatBookingsByBU: SeatBooking[]): [string, number] => {
    const mapTeamSeatsCount: Record<string, number> = {}
    reportSeatBookingsByBU.forEach(data => {
      data.seats.forEach(seat => {
        const teamId = seat.teamId || TeamExtensions.UNDEFINED_TEAM.id
        mapTeamSeatsCount[teamId] =
          mapTeamSeatsCount[teamId] !== undefined ? mapTeamSeatsCount[teamId] + 1 : 1
      })
    })
    const teamWithMaxSeats = Object.keys(mapTeamSeatsCount).reduce((a, b) =>
      mapTeamSeatsCount[a] >= mapTeamSeatsCount[b] ? a : b
    )
    let mostVisitingTeam
    switch (teamWithMaxSeats) {
      case TeamExtensions.OTHER_BUSINESS_UNIT.id:
        mostVisitingTeam = TeamExtensions.OTHER_BUSINESS_UNIT
        break

      case TeamExtensions.UNDEFINED_TEAM.id:
        mostVisitingTeam = TeamExtensions.UNDEFINED_TEAM
        break

      default:
        mostVisitingTeam = reportBusinessUnit?.teams.find(team => team.id === teamWithMaxSeats)
        break
    }
    return [
      mostVisitingTeam?.name || '-',
      mostVisitingTeam?.id ? mapTeamSeatsCount[mostVisitingTeam.id] : 0
    ]
  }

  const isAllTeams = (team?: Team) => team?.id === TeamExtensions.ALL_TEAMS.id

  return isAllTeams(reportTeam) ? (
    <DataCard
      id="most-visiting-team-card"
      title="Most Visiting Team"
      content={{
        mainValue: visitingTeam
      }}
      footer={numberSeatsBooked + ' total visits'}
    />
  ) : null
}
